import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: {
      scope: process.env.BASE_URL,
    },
    ready() {
      // Silent - app is working as expected
    },
    registered(registration) {
      // Check for updates every hour
      setInterval(() => {
        registration.update()
      }, 1000 * 60 * 60)
    },
    cached() {
      // Silent - normal behavior
    },
    updatefound() {
      // Silent - update is downloading in background
    },
    updated() {
      // New version ready for next visit - no action needed
    },
    offline() {
      // Silent - your workbox config handles offline caching
    },
    error(error) {
      // Keep error logging for debugging production issues
      console.error('Service worker error:', error)
    }
  })
}
